import React,{useState} from 'react';
import styles from './submitOfferModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import StageDetailsConfiguration from './offerConfiguration';
import Review from './offerConfigurationReview';
var moment = require('moment-timezone');

const SubmitOfferModal = (props) => {

    let [step, setStep] = useState(1);

    let [values,setValues] = useState({
        candidateID: props.candidateID,
        offerSessionId:props.isEditMode ? props.editRowValues.offerSessionId :null,
        jobTitle: props.isEditMode ? props.editRowValues.jobTitle :'',
        allocation: props.isEditMode ? props.editRowValues.allocation :'',
        offerDescription: props.isEditMode ? props.editRowValues.offerDescription :'',
        offerReviewers:props.isEditMode ? props.editRowValues.offerReviewers :'',
        packageReference: props.isEditMode ? props.editRowValues.packageReference :'',
    })

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function setSubmitValues(values){
        setValues((prevState) => ({
            ...prevState,
            jobTitle: values.jobTitle,
            allocation: values.allocation,
            offerDescription: values.offerDescription,
            offerReviewers: values.offerReviewers,
            packageReference: values.packageReference,
        }))
    }
    
    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >

                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Prepare Offer</h2>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>


                    <Col sm={12}>
                        <Container>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.showModal === true && <StageDetailsConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values} />}
                            {step === 2 && props.showModal === true && <Review nextPage={nextPage} previousPage={previousPage} values={values} handleClose={props.handleClose} refreshData={props.refreshData} GetTaskValues={props.GetTaskValues}/>}
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}
export default SubmitOfferModal;